// src/pages/Privasi.jsx
import "../styles/Pengenalan.css";

const Privasi = () => {
    return (
        <div className="pg-wrap">
            <div className="container pg-container">
                {/* Header */}
                <div className="pg-section" style={{ marginTop: 0 }}>
                    <h1 className="pg-h1">Dasar Privasi</h1>

                    <p className="pg-lead">
                        <b>Etikaf (com.etikaf.app)</b>
                        <span className="pg-dot-sep">•</span>
                        <b>Tarikh Berkuatkuasa:</b> 14 Januari 2025
                    </p>
                </div>

                {/* Sections */}
                <div className="pg-section">
                    <div className="pg-showcase">
                        <div className="pg-showcase-head">
                            <div className="pg-showcase-title">Pengenalan</div>
                            <div className="pg-showcase-sub">
                                Ringkasan bagaimana kami mengurus maklumat pengguna.
                            </div>
                        </div>

                        <div className="pg-showcase-box">
                            <div className="pg-showcase-content">
                                <p className="pg-desc" style={{ marginTop: 0 }}>
                                    Etikaf ("kami", "kita", atau "syarikat kami") menghormati privasi anda.
                                    Dasar Privasi ini menerangkan bagaimana kami mengumpul, menggunakan, dan
                                    berkongsi maklumat anda apabila anda menggunakan aplikasi kami.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pg-section">
                    <div className="pg-grid-2">
                        {/* Pengumpulan Data */}
                        <div className="pg-accordion">
                            <details open>
                                <summary>Pengumpulan Data</summary>
                                <div className="pg-acc-body">
                                    <p style={{ marginTop: 0 }}>
                                        Aplikasi kami mungkin mengumpul jenis data berikut:
                                    </p>
                                    <ul style={{ margin: "8px 0 0", paddingLeft: 18, color: "#444", lineHeight: 1.6 }}>
                                        <li>Maklumat peribadi (contoh: nama, emel) jika diberikan.</li>
                                        <li>Data penggunaan untuk tujuan analitik.</li>
                                        <li>Data lokasi (jika diaktifkan oleh pengguna).</li>
                                    </ul>
                                </div>
                            </details>

                            {/* Penggunaan Data */}
                            <details>
                                <summary>Penggunaan Data</summary>
                                <div className="pg-acc-body">
                                    <p style={{ marginTop: 0 }}>
                                        Kami menggunakan data yang dikumpul untuk:
                                    </p>
                                    <ul style={{ margin: "8px 0 0", paddingLeft: 18, color: "#444", lineHeight: 1.6 }}>
                                        <li>Meningkatkan fungsi aplikasi.</li>
                                        <li>Menyediakan pengalaman yang diperibadikan.</li>
                                        <li>Menghantar notifikasi dan kemas kini berkaitan ciri aplikasi.</li>
                                    </ul>
                                </div>
                            </details>
                        </div>

                        {/* Perkongsian Data + keselamatan */}
                        <div className="pg-accordion">
                            <details open>
                                <summary>Perkongsian Data</summary>
                                <div className="pg-acc-body">
                                    <p style={{ marginTop: 0 }}>
                                        Kami tidak berkongsi data anda dengan pihak ketiga kecuali diperlukan untuk
                                        pematuhan undang-undang.
                                    </p>

                                    <p style={{ marginBottom: 6 }}>
                                        Kami juga menggunakan perkhidmatan pihak ketiga berikut, yang mungkin memproses
                                        data anda:
                                    </p>

                                    <ul style={{ margin: 0, paddingLeft: 18, color: "#444", lineHeight: 1.6 }}>
                                        <li>
                                            Firebase Analytics{" "}
                                            (
                                            <a
                                                className="pg-link"
                                                href="https://firebase.google.com/support/privacy"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Dasar Privasi Firebase
                                            </a>
                                            )
                                        </li>
                                    </ul>
                                </div>
                            </details>

                            <details>
                                <summary>Penyimpanan & Keselamatan Data</summary>
                                <div className="pg-acc-body">
                                    <p style={{ marginTop: 0 }}>
                                        <b>Penyimpanan Data:</b> Kami menyimpan data hanya untuk tempoh yang diperlukan
                                        untuk memenuhi tujuan yang dinyatakan dalam dasar ini.
                                    </p>
                                    <p style={{ marginBottom: 0 }}>
                                        <b>Keselamatan Data:</b> Kami melaksanakan langkah keselamatan piawaian industri
                                        untuk melindungi data anda.
                                    </p>
                                </div>
                            </details>
                        </div>
                    </div>
                </div>

                {/* Contact */}
                <div className="pg-section">
                    <div className="pg-contact-card">
                        <div className="pg-contact-item">
                            <div>
                                <div className="pg-contact-title">Hubungi Kami</div>
                                <div className="pg-contact-sub">
                                    Jika ada soalan tentang Dasar Privasi ini.
                                </div>
                            </div>
                        </div>

                        <div className="pg-contact-item">
                            <div>
                                <div className="pg-contact-title">Emel</div>
                                <div className="pg-contact-sub">
                                    <a className="pg-link" href="mailto:admin@etikaf.com">
                                        admin@etikaf.com
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="pg-contact-item">
                            <div>
                                <div className="pg-contact-title">Rujukan</div>
                                <div className="pg-contact-sub">Etikaf — com.etikaf.app</div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default Privasi;
